export default __webpack_public_path__ + "svg/calendar/2026/0/enero.svg?ec8dc1fd";